import { useConnection } from "@solana/wallet-adapter-react";
import { useEffect, useState } from "react";

export type LidoStakingData = {
  lidoAPR: number;
};

export default function useLidoStaking(): LidoStakingData {
  const [lidoApr, setLidoApr] = useState(0);
  const { connection } = useConnection();

  useEffect(() => {
    const fetchLidoData = async () => {
      const { apr } = await (
        await fetch("https://solana.lido.fi/api/stats", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        })
      ).json();
      return [apr];
    };
    fetchLidoData()
      .then(([apr]) => {
        setLidoApr(apr);
      })
      .catch((err) => console.log(`Failed to fetch Lido data: ${err}`));
  }, [connection]);

  return { lidoAPR: lidoApr };
}
